import { render, staticRenderFns } from "./crudInstancesMonitorServer.vue?vue&type=template&id=625838df&scoped=true&"
import script from "./crudInstancesMonitorServer.vue?vue&type=script&lang=js&"
export * from "./crudInstancesMonitorServer.vue?vue&type=script&lang=js&"
import style0 from "./crudInstancesMonitorServer.vue?vue&type=style&index=0&id=625838df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625838df",
  null
  
)

export default component.exports